import React from 'react';

import OtherChecksFormValue  from '../../../models/OtherChecksFormValue';
import { OtherChecksForm } from '../../../models/OtherChecksForm';
import OtherCheck from '../../../models/OtherChecks';

import { Select, OutlinedInput, createStyles, Theme, withStyles, FormControlLabel, RadioGroup, Radio, Typography,  } from '@material-ui/core';
import { Info, RadioButtonUnchecked , RadioButtonChecked }from '@material-ui/icons';

import styles from '../readyForCarriageCheck.module.css';
import commonStyles from '../../common/common.module.css';

const materialStyles = (theme: Theme) =>
  createStyles({
    materialIcon: {
      fontSize: '21px',
      marginLeft: '20px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    label: {
      color: 'var(--primaryblue)',
      fontSize: '14px',
      minWidth: '40px'
    },
    width40: {
      width: '50%',
      paddingLeft: '20px'
    },
    radioGroup: {
      minWidth: '200px',
    },
    radioScale: {
      transform: 'scale(0.9)',
    },
    flexAuto: {
      flex: 'auto',
    }
  });

interface OtherChecksProps {
  classes: any;
  awbCode: string;
  otherChecks: OtherCheck;
  handleChange: (event: any ) => void;
  checkElement: (check: boolean) => JSX.Element;
  onlyRead?: boolean;
  deliveredDate: string;
};

const TEXT_FIELD_PADDINGS: string = '0px 3px 0px 7px';
const TEXT_FIELD_WIDTH: string = '56px';
const SELECT_FONT_SIZE: string = '12px';
const TEXT_FIELD_HEIGHT: string = '100%';


const otherChecks = (props: OtherChecksProps) => {

  const otherChecksForm: Array<JSX.Element> = props.otherChecks.r4c_form.map( (item: OtherChecksForm, index: number) => {

    let infoText: string | null = null;
    if(item.info_url){
      if(typeof(item.info_url) === 'string') {
        infoText = item.info_url;
      } else if(item.info_url[props.awbCode]) {
        infoText = item.info_url[props.awbCode];
      } else if(item.info_url['default']) {
        infoText = item.info_url['default'];
      }
    }
    const info: JSX.Element | null = infoText? 
        <Info color="primary" className={ props.classes.materialIcon } onClick={ () =>  window.open(infoText as string ,'_blank') } />
        : null;
      
    
    const selectOptions: Array<JSX.Element> = item.values.map((opt: OtherChecksFormValue, ind: number) => {
      
      return (
          <FormControlLabel 
            value={ opt.value }
            id={`${ ind }`}
            key={ ind }
            disabled={ (props.onlyRead) || (props.deliveredDate !== null) }
              control={
                <Radio 
                  color="primary" 
                  icon={ <RadioButtonUnchecked fontSize="small" /> } 
                  checkedIcon={ <RadioButtonChecked fontSize="small" /> }
                  id={`${ index }`}
                /> 
              } 
              label={<Typography className={props.classes.label}> { opt.value }</Typography>}
              classes={{
                root: props.classes.radio 
              }}
              className={ props.classes.radioScale }
            />
      )
    });

    const flag: JSX.Element =  props.checkElement(props.otherChecks.r4c_form_data.r4c_form_green[index]);
      
    return (
      <div key={ index } className={ styles.wrapperForm }>

        <div className={ `${ styles.elementsWrapperInfo } ${ props.classes.flexAuto }` }>

          <div className={ styles.name }>{ item.name }</div>

          <div>{ info }</div>

        </div>

        <div className={ `${ commonStyles.dFlex } ${ props.classes.width40 } ${ styles.radioWrapper }` }>

          <RadioGroup
            aria-label=""
            name=""
            row={ true }
            onChange={ props.handleChange }
            value={ props.otherChecks.r4c_form_data.r4c_form_data[index] }
            id={`${ index }`}
            className={ props.classes.radioGroup }
          >

          { selectOptions }

          </RadioGroup>

          <div className={ `${ styles.check } ${ commonStyles.mlauto }` }>{ flag }</div>

        </div>

      </div>
    )
  });

  return (
    <div className= { `${ commonStyles.wrapper } ${ commonStyles.px0 } ${ styles.height200 } ${ commonStyles.tabBr }` }>

      <div className={ `${ styles.wrapper } ${ commonStyles.px3 }` }>

        { otherChecksForm }

      </div>

    </div>
  );
};

export default withStyles(materialStyles)(otherChecks);